import React, { useEffect } from 'react';

import ActionButton from '~components/atoms/ActionButton';
import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TUpdateCustomerTransferStatusReduxParams, TUpdateStockOutStatusReduxParams } from '~types/feat/approval';
import UtilFunctions from '~utils/functions';
import * as Styles from './ConfirmUpdateCustomerTransferStatusModal.module.scss';
import { TransactionStatusEnum } from '~utils/enums';

const ConfirmUpdateCustomerTransferStatusModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.approval.modals.confirmUpdateCustomerTransferStatusModalIsOpen);
    const tempUpdateCustomerTransferState = useAppSelector(state => state.approval.tempUpdateCustomerTransferState);
    const isLoading = useAppSelector(state => state.approval.loadings.updateCustomerTransferStatus);
    const error = useAppSelector(state => state.approval.errors.updateCustomerTransferStatus);

    const getStatus = () => {
        switch (tempUpdateCustomerTransferState.status) {
            case (TransactionStatusEnum.Approved): return 'Approve';
            case (TransactionStatusEnum.Rejected): return 'Reject';
            default: return '';
        }
    };

    const setIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateCustomerTransferStatusModalIsOpen(open));

    const updateCustomerTransferStatus = (data: TUpdateCustomerTransferStatusReduxParams) => dispatch(combinedActions.approvalUpdateCustomerTransferStatusAttempt(data));

    const handleSubmitClick = () => {
        updateCustomerTransferStatus(tempUpdateCustomerTransferState);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        getStatus() === 'Approve' ? Styles['confirm-approve'] : '',
        getStatus() === 'Reject' ? Styles['confirm-reject'] : '',
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.approvalResetUpdateCustomerTransferStatusState());
        }
        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()} Customer Transfer?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />
                <ActionButton
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                    disabled={isLoading}
                />
            </div>

            {error && (
                <Text
                    label={error}
                    isError
                />
            )}
        </Modal>
    );
};

export default ConfirmUpdateCustomerTransferStatusModal;
